import { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import api from '../../lib/api';
import { when } from './fmt';

export const HistoryList = ({ quarter, tick, isAdmin }) => {
  const [items, setItems] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { api.get('/trainer-targets/history', { params: all ? {} : { quarter } }).then(r => setItems(r.data.items)); }, [quarter, all, tick]);
  return (
    <Card className="p-4 space-y-3" data-testid="tt-history">
      <label className="text-xs text-slate-600 inline-flex items-center gap-2">
        <input type="checkbox" checked={all} onChange={e => setAll(e.target.checked)} data-testid="tt-history-all" />{isAdmin ? 'Show every quarter and salary changes' : 'Show every quarter'}
      </label>
      {!items ? null : items.length === 0 ? <p className="text-sm text-slate-400">No changes yet.</p> : items.map(i => (
        <div key={i.id} className="text-xs border-l-2 border-violet-200 pl-3" data-testid={`tt-history-${i.id}`}>
          <div className="text-slate-800 font-medium">{i.change}</div>
          <div className="text-slate-400">{i.quarter ? `${i.quarter} · ` : ''}{i.by} · {when(i.at)}{i.note ? ` · “${i.note}”` : ''}</div>
        </div>
      ))}
    </Card>
  );
};
